/**
 * File: contactForm.js.
 *
 * Import and initialize functions for Contact Form
 */

 const $ = require('jquery');

 export default {
    wpcf7Elem: document.querySelector( '.wpcf7' ),
    contactWrapper: document.querySelector( '.contact-form-wrapper' ),
	init() {
        if (this.wpcf7Elem && this.contactWrapper) {
            this.customDropdown();
            this.customCheckbox();
            this.render();
        }
	},
    customCheckbox() {
        const checkboxes = document.querySelectorAll('.wpcf7-checkbox label input[type=checkbox]');

        [...checkboxes].map(item => {
            item.addEventListener('click', () => {
                return item.checked ? item.parentElement.classList.add('checked') : item.parentElement.classList.remove('checked');
            });
        })
    },
    customDropdown() {
        const selectField = document.querySelectorAll('.udp-contact-form .dropdown');
        
        [ ...selectField ].map((field) => {
            const select = field.querySelector('select');

            // cereate ul element that lists dropdown option from original select field
            const ul = document.createElement('ul');
            ul.setAttribute('class', 'select-dropdown');

            [ ...select.options ].forEach((option) => {
            const li = document.createElement('li');
            li.innerHTML = option.innerHTML;
            ul.appendChild(li);
            });


            // append input and list to select container
            field.appendChild(ul);

            this.selectDropdown(select, ul);
        });
    },
    selectDropdown(select, dropdown) {
        const options = dropdown.querySelectorAll('ul li');

        $(document).on('click', (e) => {
            if ($(e.target).is(select)) {
            $(dropdown).toggleClass('visible');
            } else if (! $(e.target).is(dropdown) && $(dropdown).hasClass('visible')) {
            $(dropdown).removeClass('visible');
            }
        });

        options.forEach((option, i) => {
            $(option).on('click', () => {
            $(option).addClass('option-selected');
            if (select.options[ i ].value === option.innerText) {
                select.options[ i ].selected = 'selected';
            }
            $(dropdown).removeClass('visible');
            });
            $(document).on('click', (e) => {
            if ($(e.target).is(option) === false) {
                $(option).removeClass('option-selected');
            }
            });
        });
    },
	render() {
        const title = this.contactWrapper.querySelector('.contact-form-title .qodef-m-title');
        const paragraph = this.contactWrapper.querySelector('.contact-form-title .qodef-m-text p');
        const subtitle = this.contactWrapper.querySelector('.contact-form-title .qodef-m-subtitle');
        const contactWidget = document.querySelector('.elementor-widget-wp-widget-allsmiles_core_contact_form_7');

        if (this.contactWrapper) {
            this.wpcf7Elem.addEventListener('wpcf7mailsent', () => {
                if (subtitle) subtitle.style.display = 'none';
                title.innerHTML = 'Thank you!'
                paragraph.innerHTML = 'We’ll contact you as soon as possible.';
                contactWidget.style.display = 'none';
            }, false);
        }
	},
	finalize() {
	// JavaScript to be fired on all pages, after page specific JS is fired
	},
};
  